import * as fromUserData from './user-data.actions';
import { UserDataModel } from './user-data.model';

export interface UserDataState {
    userData: UserDataModel
}

const initState: UserDataState = {
  userData : new UserDataModel({
      name: '',
      lastname1: '',
      lastname2: '',
      email: '',
      phone1: '',
      phone2: '',
      currentCompany: '',
      coverage: '',
      specSheet: '',
      driverIdentification: '',
      license: '',
      checkPrivacy: false,
      checkCalling: false
  })
};

export function userDataReducer(state = initState, action: fromUserData.actions): UserDataState {

    switch (action.type) {

        case fromUserData.SET_USER_DATA:
            return {
                userData: {... action.userData}
            };

        case fromUserData.UNSET_USER_DATA:
            return {
                userData: new UserDataModel({
                    name: '',
                    lastname1: '',
                    lastname2: '',
                    email: '',
                    phone1: '',
                    phone2: '',
                    currentCompany: '',
                    coverage: '',
                    specSheet: '',
                    driverIdentification: '',
                    license: '',
                    checkPrivacy: false,
                    checkCalling: false
                })
            };

        default:
            return state;
    }

}
